import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import CardOpion from './ViewProfile/CardOpinion';
import ButtonBase from './Buttons/ButtonBase';
import { overflow } from 'styled-system';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
    fontWeight: 'bold',
  },
  text: {
    color: '#484848',
    lineHeight: 'normal',
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {
    marginTop: 24,
    color: '#013957',
    cursor: 'pointer',
    width: 'fit-content',
    display: 'flex'
  },
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
    width: '100%'
  },
}));

const ExpansionPanel = withStyles({
  root: {
    color: '#484848',
    marginBottom: 10,
    borderRadius: 4,
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    marginTop: 24,
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',

  },
  content: {
    margin: 0,
    width: '100%',
    flexFlow: 'column',
    //alignItems: 'center',
    padding: '16px 24px',
    cursor: 'auto',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#013957',
  },

  expanded: {
    //margin:0
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: 0,
    display: 'block',
  },
})(MuiExpansionPanelDetails);

export default function ExpIconBottom({
  title,
  sumcontent,
  detcontent,
  button,
  length,
  hideButton,
  expansionButton,
  buttonFunction,
  scrollable
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event) => {
    setExpanded(expanded ? false : true);
  };

  return (
    <div className={classes.root}>
      <ExpansionPanel expanded={expanded} >
        <ExpansionPanelSummary aria-controls="panel2a-content">
          {title && <p className={classes.title}>{title}</p>}
          <div
            className={classes.summaryContent}
            style={{
              overflowY: scrollable ? 'auto' : 'inherit',
              height: scrollable ? 350 : 'initial',
              borderBottom: button && !expanded && length ? 'thin solid #e7e7e7' : 'inherit'
            }}
          >
            {sumcontent}
          </div>
          {detcontent && expansionButton && !expanded &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div className={classes.expandButton} onClick={handleChange}>
                <Typography className={classes.seeMore}>{expanded ? null : 'Ver más'}</Typography>
                {expanded ? null : <ExpandMoreIcon />}
              </div>
            </div>
          }

          {button && !expanded && !hideButton && (
            <div style={{ alignSelf: 'start', marginTop: 40 }}>
              <ButtonBase 
                onClick={buttonFunction ? buttonFunction : null}
                variant="primary"
              >
                {button}
              </ButtonBase>
            </div>
          )}

          {detcontent && expanded && expansionButton &&
            <ExpansionPanelDetails>
              {detcontent}

              {button && expanded && (
                <div style={{ alignSelf: 'start', marginTop: 40 }}>
                  <ButtonBase variant="primary">{button}</ButtonBase>
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className={classes.expandButton} onClick={handleChange}>
                  <Typography className={classes.seeMore}>{expanded ? 'Ver menos' : null}</Typography>
                  {expanded ? <KeyboardArrowUpIcon /> : null}
                </div>
              </div>
            </ExpansionPanelDetails>}
        </ExpansionPanelSummary>
      </ExpansionPanel>
    </div>
  );
}
